import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"add\"><defs><style type=\"text/css\"></style></defs><path d=\"M736 480l-192 0 0-192C544 268.8 531.2 256 512 256S480 268.8 480 288l0 192-192 0C268.8 480 256 492.8 256 512s12.8 32 32 32l192 0 0 192C480 755.2 492.8 768 512 768s32-12.8 32-32l0-192 192 0C755.2 544 768 531.2 768 512S755.2 480 736 480z\" p-id=\"3209\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol